import isObject from './is-object';

const isEmptyObject = (data: any) => {
  const isObjectType = isObject(data);

  if (isObjectType) {
    return Object.keys(data).length === 0;
  } else {
    return true;
  }
};

export default isEmptyObject;
